import { AttachMoney, Schedule } from '@material-ui/icons';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@material-ui/lab';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setEntry } from '../redux/entry';
import {
  baseDraft,
  ENTRY_TYPE_EXPENSE,
  ENTRY_TYPE_SERVICE,
} from '../config/staticValues';

const NewEntryControl = () => {
  const timecardId = useSelector((state) => state.general.timecardId);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const getEmptyEntry = () => {
    const emptyEntry = Object.assign({}, baseDraft);
    emptyEntry.id = -1;
    emptyEntry.type = ENTRY_TYPE_SERVICE;
    emptyEntry.timecardId = timecardId;
    return emptyEntry;
  };
  const actions = [
    {
      icon: <AttachMoney />,
      name: 'Add Expense',
      action: () =>
        dispatch(
          setEntry({
            id: -1,
            type: ENTRY_TYPE_EXPENSE,
            timecardId: timecardId,
            noCharge: false,
            payBonus: true,
          })
        ),
    },
    // {
    //   icon: <Schedule />,
    //   name: 'Add Entry',
    //   action: () => dispatch(setEntry(getEmptyEntry())),
    // },
  ];
  return (
    <SpeedDial
      ariaLabel="Create New Expense or Entry"
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      direction="right"
      className="post2-speeddial"
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={action.action}
        />
      ))}
    </SpeedDial>
  );
};

export default NewEntryControl;
